export const applyFilters = <T>(items: T[], filters: Record<string, any>): T[] => {

    if (!items || items.length === 0) return [];
    if (!filters || Object.keys(filters).length === 0) return items;

    return items.filter(hs =>
        Object.entries(filters).every(([key, value]) => {
            const fieldValue = getFieldValue(hs, key);
            if (value === "!null") return fieldValue != null;
            if (value === null) return fieldValue == null;
            if (typeof fieldValue === "string" && typeof value === "string") {
                return fieldValue.toLowerCase().includes(value.toLowerCase());
            }
            if (Array.isArray(value) && Array.isArray(fieldValue)) {
                const lowerFieldValue = fieldValue.map((fv: any) => typeof fv === "string" ? fv.toLowerCase() : fv);
                return value.every((v: any) => {
                    const lowerV = typeof v === "string" ? v.toLowerCase() : v;
                    return lowerFieldValue.includes(lowerV);
                });
            }
            return fieldValue === value;
        })
    );
};


export const getFieldValue = (obj: any, path: string): any =>
    path.split(".").reduce((acc: any, part: string) => (acc && acc[part] !== undefined ? acc[part] : null), obj);